import { css } from '@emotion/react';

export const mapStyles = {
  wrapper: css`
    width: 100%;
    height: 100%;
  `,
  container: css`
    position: relative;
    display: flex;
    align-items: flex-end;
  `,
  map: css`
    position: absolute; 
    top: 0;
    left: 0; 
    bottom: 0; 
    right: 0;
  `,
  animation: css`
    transition: fill 1.5s;
  `,
};

const height = 30;
export const legendStyles = {
  wrapper: css`
    position: relative;
    height: ${height}px;
  `,
  container: css`
    display: flex;
    flex-direction: column;
  `,
  labelContainer: css`
    position: relative;
    font-size: 12px;
    line-height: 12px;
  `,
  tick: css`
    position: absolute;
    top: ${(height - 12) / 2}px;
    // horizontally center ticks based on where they land
    transform: translateX(-50%);
  `,
  gradient: css`
      width: 100%;
      height: ${height}px;
    `,
};
